import { logRegistryEvent } from 'apis/analytics';
import {
  addRegistryItem,
  removeRegistryItem,
  getActiveRegistry,
} from 'apis/registry';
import { reportError } from 'apis/sentry';

const BASE = 'GIFT_REGISTRY/';
export const ACTIVATION = BASE + 'ACTIVE';
const ADD_EVENT = BASE + 'ADD_TO_GIFT_REGISTRY';
const ADD_EVENT_LOADING = ADD_EVENT + '_INITIATE';
const ADD_EVENT_SUCCESS = ADD_EVENT + '_SUCCESS';
const ADD_EVENT_FAILURE = ADD_EVENT + '_FAILURE';
const REMOVE_EVENT = BASE + 'REMOVE_FROM_GIFT_REGISTRY';
const REMOVE_EVENT_LOADING = REMOVE_EVENT + '_INITIATE';
const REMOVE_EVENT_SUCCESS = REMOVE_EVENT + '_SUCCESS';
const REMOVE_EVENT_FAILURE = REMOVE_EVENT + '_FAILURE';

const COOKIE_CONSENT_BASE = 'ikeaCookieConsent/';
export const COOKIE_CONSENT_CHANGED = COOKIE_CONSENT_BASE + 'changed';

type AddEventPayload = {
  registryId?: string; // optional, defaults to current active registry
  itemNo: string;
  quantity: string;
  source: string;
};

type RemoveEventPayload = {
  registryId: string;
  itemNo: string;
  source: string;
};

export const publish = window.ikea.pubsub.publish;

const addEventCallback = (payload: AddEventPayload) => {
  publish(ADD_EVENT_LOADING, { payload });
  addRegistryItem(payload.registryId, payload.itemNo, Number(payload.quantity))
    .then(({ data }) => {
      if (data.addRegistryItems.__typename === 'AddRegistryItemsPayload') {
        publish(ADD_EVENT_SUCCESS, {
          title: data.addRegistryItems.registry.title,
          registryId: data.addRegistryItems.registry.id,
          payload,
        });
      } else {
        publish(ADD_EVENT_FAILURE, {
          payload,
          error: data.addRegistryItems.__typename,
        });
      }
      logRegistryEvent('registry_add_item', `source: ${payload.source}`);
    })
    .catch((err) => {
      reportError(err, { context: `${ADD_EVENT} catch` });
      publish(ADD_EVENT_FAILURE, { payload });
    });
};

const removeEventCallback = (payload: RemoveEventPayload) => {
  publish(REMOVE_EVENT_LOADING, { payload });

  if (!payload.registryId) {
    getActiveRegistry()
      .then(({ data }) => {
        if (data.activeRegistry.__typename === 'ActiveRegistryPayload') {
          (payload.registryId = data.activeRegistry.registry.id),
            removeItemFromRegistry(payload);
        } else {
          publish(REMOVE_EVENT_FAILURE, { payload });
        }
      })
      .catch((err) => {
        reportError(err, { context: `${REMOVE_EVENT} catch` });
        publish(REMOVE_EVENT_FAILURE, { payload });
      });
  } else {
    removeItemFromRegistry(payload);
  }
};

function removeItemFromRegistry(payload: RemoveEventPayload) {
  removeRegistryItem(payload.registryId, payload.itemNo)
    .then(({ data }) => {
      if (
        data.removeRegistryItems.__typename === 'RemoveRegistryItemsPayload'
      ) {
        publish(REMOVE_EVENT_SUCCESS, {
          title: data.removeRegistryItems.registry.title,
          registryId: data.removeRegistryItems.registry.id,
          payload: payload,
        });
      } else {
        publish(REMOVE_EVENT_FAILURE, {
          payload: payload,
          error: data.removeRegistryItems.__typename,
        });
      }
      logRegistryEvent('registry_remove_item', `source: ${payload.source}`);
    })
    .catch((err) => {
      reportError(err, { context: `removeRegistryItem() catch` });
      publish(REMOVE_EVENT_FAILURE, { payload: payload });
    });
}

type ActiveEventPayload = {};

export const publishActivation = (payload: ActiveEventPayload = {}) => {
  window.ikea.pubsub.subscribe<IkeaEvent<AddEventPayload>>(
    ADD_EVENT,
    addEventCallback
  );
  window.ikea.pubsub.subscribe<IkeaEvent<RemoveEventPayload>>(
    REMOVE_EVENT,
    removeEventCallback
  );
  publish<IkeaEvent<ActiveEventPayload>>(ACTIVATION, payload);
};
